import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
// import Lara from '@primeng/themes/lara';
// import Nora from '@primeng/themes/nora';
// import Material from '@primeng/themes/material';

const PrimengPreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          color: 'var(--button-primary)', // background color of the element
          // inverseColor: 'var(--button-secondary-text)',
          hoverColor: 'var(--button-primary-accent)', // background color of the element on hover
          // activeColor: 'var(--button-secondary-accent)',
        },
        content: {
          color: 'var(--text-primary)', // Default text color on surface (secondary elements)
        },
        highlight: {
          background: 'var(--accent-background)', // Default background color for highlighted elements
          focusBackground: 'var(--focus-border)', // Background color when element receives focus
          color: 'var(--text-primary)', // Text color for highlighted elements
          focusColor: 'var(--text-secondary)', // Text color when element receives focus
        },
        // Not sure if bellow is needed
        // surface: {
        //   ground: 'var(--page-background)',
        //   card: 'var(--form-background)',
        //   default: 'var(--form-background)',
        //   hover: 'var(--form-background)',
        // },
      },
      dark: {
        primary: {
          color: 'var(--button-primary)', // background color of the element
          // inverseColor: 'var(--button-secondary-text)',
          hoverColor: 'var(--button-primary-accent)', // background color of the element on hover
          // activeColor: 'var(--button-secondary-accent)',
        },
        content: {
          color: 'var(--text-primary)', // Default text color on surface (secondary elements)
        },
        highlight: {
          background: 'var(--accent-background)', // Default background color for highlighted elements
          focusBackground: 'var(--focus-border)', // Background color when element receives focus
          color: 'var(--text-primary)', // Text color for highlighted elements
          focusColor: 'var(--text-secondary)', // Text color when element receives focus
        },
        // Not sure if bellow is needed
        // surface: {
        //   ground: 'var(--page-background)',
        //   card: 'var(--form-background)',
        //   default: 'var(--form-background)',
        //   hover: 'var(--form-background)',
        // },
      },
    },
  },
});

export default PrimengPreset;
